import { render, staticRenderFns } from "./ReporteCostos.vue?vue&type=template&id=01e8f58a&scoped=true"
import script from "./ReporteCostos.vue?vue&type=script&lang=js"
export * from "./ReporteCostos.vue?vue&type=script&lang=js"
import style0 from "./ReporteCostos.vue?vue&type=style&index=0&id=01e8f58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8f58a",
  null
  
)

export default component.exports